import { CustomTooltip, IconButton } from '@fountain/fountain-ui-components';
import { Grid } from '@material-ui/core';
import {
  Icon,
  DownloadOutlineIcon,
  PencilOutlineIcon,
} from '@fountain/ripple/icon';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import useStyles from 'containers/DataValidationModal/components/FileField/styles';
import { EditButtonBaseProps } from 'containers/DataValidationModal/components/FileField/types';
import { TestId } from 'containers/DataValidationModal/components/testData';
import messages from 'shared/global/messages';
import { iconLabels } from 'shared/iconLabels';

export type EditButtonProps = EditButtonBaseProps;

export const EditButton: FC<EditButtonProps> = ({
  applicantBlob,
  isMobile,
  setIsEditable,
  showButtons,
  url,
}) => {
  const styles = useStyles();
  const intl = useIntl();
  return (
    <Grid data-testid={TestId.EDIT_BUTTON}>
      <a
        href={url ?? applicantBlob[0].download_url}
        rel="noopener noreferrer"
        target="_blank"
      >
        <CustomTooltip
          dense
          title={<FormattedMessage {...messages.download} />}
        >
          <IconButton
            aria-label={intl.formatMessage(messages.download)}
            className={showButtons ? styles.hoverButton : styles.noHoverButton}
          >
            <Icon icon={DownloadOutlineIcon} size="sm" color="neutral-400" />
          </IconButton>
        </CustomTooltip>
      </a>
      <CustomTooltip title={<FormattedMessage {...messages.edit} />} dense>
        <IconButton
          aria-label={intl.formatMessage(iconLabels.edit)}
          onClick={() => setIsEditable(true)}
          className={
            showButtons && !isMobile ? styles.hoverButton : styles.noHoverButton
          }
        >
          <Icon icon={PencilOutlineIcon} size="xs" color="neutral-400" />
        </IconButton>
      </CustomTooltip>
    </Grid>
  );
};
